import "./know-your-business.page.scss";
import "../../html/header/header";
import "../../html/footer/footer";
import { initSlider } from "../../js/slider";

window.addEventListener("load", () => {
    initSlider();
});
